import { TRPCClientError } from '@trpc/client';
import { type CreateTRPCReact, createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '#server/api-types';

// Explicit annotation avoids TS2742 (inferred type references internal tRPC hashed dist files).
export const api: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>();

/** The tRPC error code (e.g. `UNAUTHORIZED`) of a failed call, if it is one. */
export function apiErrorCode(error: unknown): string | undefined {
  if (!(error instanceof TRPCClientError)) return undefined;
  const data: unknown = error.data;
  if (typeof data !== 'object' || data === null || !('code' in data)) return undefined;
  return typeof data.code === 'string' ? data.code : undefined;
}
